<template>
	<div class="model1">
		<!-- 文章列表部分 -->
		<div class="m1_info_box">
			<!-- <div class="m1_search_box">
                <span @click="tabclickfn(-1)" class="m1_tab_btn m1_search_active">不限<img src="../assets/main/choose.jpg" alt=""></span>
                <span @click="tabclickfn(0)" class="m1_tab_btn">一周内<img src="../assets/main/choose.jpg" alt=""></span>
                <span @click="tabclickfn(1)" class="m1_tab_btn">一月内<img src="../assets/main/choose.jpg" alt=""></span>
                <span @click="tabclickfn(2)" class="m1_tab_btn" style="margin-right:26px;">一年内<img src="../assets/main/choose.jpg" alt=""></span>
                自定义:
                <el-date-picker
                    @change="changeDateFn"
                    style="width:250px;border: 1px solid #F3F3F3;margin-left:12px;"
                    size="small"
                    v-model="dateRaneg"
                    unlink-panels
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <h5><img src="../assets/main/title_icon.jpg" alt="">碳排放</h5> -->
			<ul class="m1_info_ul" style="margin-top:20px;">
				<li v-for="(item, index) in dataList" :key="index">
					<a
						class="m1_info_li_l"
						:href="
							'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
								item.docid +
								'&leafid=' +
								item.leafid
						"
						target="_blank"
					>
						<h6>{{ item.deliveddate | subData2 }}</h6>
						<span>{{ item.deliveddate | subData1 }}</span>
					</a>
					<a
						class="m1_info_li_r"
						:href="
							'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
								item.docid +
								'&leafid=' +
								item.leafid
						"
						target="_blank"
					>
						<h6
							v-html="
								item.title.replace(
									/<\/?(div|p|span|h3|h6|a)[^>]*>/g,
									''
								)
							"
						></h6>
						<span
							v-html="
								item.summary.replace(
									/<\/?(div|p|span|h3|h6|a)[^>]*>/g,
									''
								)
							"
						></span>
					</a>
				</li>
				<el-empty
					v-if="dataList.length <= 0 && loading == false"
					description="暂无数据!"
				></el-empty>
				<el-empty
					v-if="loading == true"
					description="加载中!"
				></el-empty>
			</ul>
			<div class="pagination_box">
				<el-pagination
					v-if="dataList.length > 0"
					background
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-size="pagesize"
					layout="total, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';
import echarts from 'echarts';

export default {
	// 普通二级页(默认)
	props: ['currentChoose'],
	components: {},
	data() {
		return {
			dateRaneg: [], //日期
			startDate: '', //日历开始时间
			endDate: '', //日历结束时间
			dataType: '', //时间选项 0是 一周 1 是一个月 2 是一年 不限 ''
			currentPage: 1, //当前页
			loading: false, //表格加载
			total: 0, //总页数
			pagesize: 10, //每页条数
			dataList: [], //文章列表数据
		};
	},
	watch: {
		currentChoose(val) {
			this.currentPage = 1;
			this.fetchDataList(val); //获取文章列表
		},
	},
	computed: {},
	created() {},
	mounted() {
		setTimeout(() => {
			$('.el-range-editor--small.el-input__inner').css(
				'border',
				'1px solid #F3F3F3'
			);
			// $('.el-pagination.is-background .el-pager li:not(.disabled).active').css('background','#4EAC41');
			$('.el-pagination__editor.el-input .el-input__inner').css(
				'border',
				'1px solid #E6E6E6!important'
			);
			// 分页样式
			// $('.el-pagination.is-background .el-pager li:not(.disabled).active').css('background-color', 'rgb(78, 172, 65)');
			// $('.el-pagination.is-background .el-pager li:not(.disabled).active').css('background-color', 'rgb(78, 172, 65)');
		}, 200);

		this.fetchDataList(this.currentChoose);
	},
	methods: {
		//点击事件切换文章列表
		tabclickfn(num) {
			$('.m1_tab_btn').removeClass('m1_search_active');
			if (num == -1) {
				this.dataType = '';
				$('.m1_tab_btn')
					.eq(0)
					.addClass('m1_search_active');
			} else {
				this.dataType = num;
				$('.m1_tab_btn')
					.eq(Number(num) + 1)
					.addClass('m1_search_active');
			}

			this.startDate = '';
			this.endDate = '';
			this.dateRaneg = [];

			this.currentPage = 1;
			this.fetchDataList(this.currentChoose);
		},
		// 点击日历切换函数
		changeDateFn(res) {
			if (this.dateRaneg.length > 0) {
				let startDate = magic.TimestampToDateTime(res[0]);
				let endDate = magic.TimestampToDateTime(res[1]);

				startDate
					? (this.startDate = startDate.substring(0, 10))
					: (this.startDate = '');
				endDate
					? (this.endDate = endDate.substring(0, 10))
					: (this.endDate = '');

				this.dataType = '';
				$('.m1_tab_btn').removeClass('m1_search_active');

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
			}
		},
		//获取数据列表
		fetchDataList(_uid) {
			// dateType：0是 一周 1 是一个月 2 是一年;"startDate":"2022-05-01","endDate":"2022-05-02"
			let params = {
				uid: _uid,
				pagesize: this.pagesize,
				curpage: this.currentPage,
				dateType: this.dataType,
				startDate: this.startDate,
				endDate: this.endDate,
			};
			this.loading = true;
			api.getarticleList(params).then((res) => {
				//console.log(res, 'list');
				this.dataList = res.data.rows;
				this.total = res.data.total;
				this.loading = false;
			});
		},
		//翻页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fetchDataList(this.currentChoose);
		},
	},
	filters: {
		subData1: function(value) {
			return value.substring(0, 7);
		},
		subData2: function(value) {
			return value.substring(8, 10);
		},
	},
};
</script>
<style scoped lang="less">
.model1 {
	width: 890px;
	height: 100%;
	overflow: hidden;
	padding: 14px 30px;
	background: #fff;
}

//文章列表部分
.m1_info_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}
.m1_info_box h5 {
	width: 100%;
	height: 70px;
	line-height: 70px;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-top: 30px;
}
.m1_info_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}
// 搜索框部分
.m1_search_box {
	position: absolute;
	top: 50px;
	right: 0;
	height: 32px;
	line-height: 32px;
}
.m1_search_box span {
	width: 70px;
	height: 30px;
	background: #ffffff;
	border: 1px solid #e7ede5;
	display: inline-block;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #222222;
	text-align: center;
	line-height: 30px;
	position: relative;
	margin-right: 8px;
	cursor: pointer;
}
.m1_search_active {
	background: #edf7ec !important;
	border: 1px solid #4eac41 !important;
}
.m1_search_box span img {
	display: none;
}
.m1_search_active img {
	display: block !important;
	position: absolute;
	bottom: 0;
	right: 0;
}
.el-range-editor--small .el-range-input {
	border: 1px solid #ccc !important;
}
.m1_info_ul {
	width: 100%;
	overflow: hidden;
}
.m1_info_ul li {
	width: 100%;
	height: 77px;
	border-bottom: 1px solid #e7ede5;
	padding: 30px 0;
	cursor: pointer;
}

.m1_info_li_l {
	width: 126px;
	height: 100%;
	text-align: center;
	float: left;
	border-right: 1px solid #f3f3f3;
}
.m1_info_li_l h6 {
	font-size: 22px;
	font-family: Arial;
	font-weight: 400;
	color: #1b1b1b;
	width: 100%;
	text-align: center;
}
.m1_info_li_l span {
	width: 100%;
	display: block;
	text-align: center;
	font-size: 14px;
	color: #999;
}
.m1_info_li_r {
	padding-left: 36px;
	float: left;
	width: 625px;
}
.m1_info_li_r h6 {
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #4d4d4d;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-bottom: 6px;
}
.m1_info_li_r h6:hover {
	color: #4eac41;
}
.m1_info_li_r span {
	display: block;
	width: 100%;
	line-height: 24px;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #808080;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2; /* 这里是超出几行省略 */
	overflow: hidden;
}
// 分页
.pagination_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 70px;
	margin-top: 50px;
	text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/mode2.vue